export default __webpack_public_path__ + "static/media/applebtn.4aebe5a6.svg";